import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ModalImovel from "../components/ModalImovel";
import { FaArrowUp, FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";
import perfilImg from "./fotoprofile.jpg";

// Importando a imagem local
import heroImage from "./backgroubd.jpg";

export default function Home() {
  const [destaques, setDestaques] = useState([]);
  const [imovelSelecionado, setImovelSelecionado] = useState(null);
  const [mostrarTopo, setMostrarTopo] = useState(false);
  const [mensagemIndex, setMensagemIndex] = useState(0);
  const mensagens = [
    "Transformando sonhos em realidade!",
    "O imóvel ideal para você!",
    "Venha conhecer as melhores oportunidades!",
  ];

  useEffect(() => {
    const fetchDestaques = async () => {
      try {
        const q = query(collection(db, "imoveis"), where("destaque", "==", true));
        const querySnapshot = await getDocs(q);
        const imoveisArray = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDestaques(imoveisArray);
      } catch (error) {
        console.error("Erro ao buscar imóveis em destaque:", error);
      }
    };
    fetchDestaques();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setMostrarTopo(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setMensagemIndex((prevIndex) => (prevIndex + 1) % mensagens.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />

      <header className="relative h-screen flex flex-col items-center justify-center text-center text-white px-6">
  {/* Imagem de fundo com desfoque */}
  <div
    className="absolute inset-0 bg-cover bg-center"
    style={{
      backgroundImage: `url(${heroImage})`,
      filter: "blur(5px) brightness(60%)",
    }}
  ></div>

  <motion.div
    className="relative z-10 max-w-3xl"
    initial={{ opacity: 0, y: -50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
  >
    <h2 className="text-5xl md:text-6xl font-extrabold leading-tight drop-shadow-lg">
      Marineide Imóveis <span className="text-yellow-400">ABC / SP</span>
    </h2>
    
    {/* Mensagem animada abaixo do título */}
    <motion.p
      className="text-xl mt-3 text-gray-200 drop-shadow-md"
      key={mensagemIndex}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.8 }}
    >
      {mensagens[mensagemIndex]}
    </motion.p>

    {/* Botão de ação */}
    <a
      href="#imoveis"
      className="mt-6 inline-block bg-yellow-500 text-white text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-yellow-700 transition transform hover:scale-105 animate-pulse"
    >
      Ver Imóveis
    </a>

    {/* 🔽 Indicação para rolar a página - Agora com SVG para garantir a cor branca 🔽 */}
    <motion.div
      className="mt-10 flex flex-col items-center text-white text-sm font-light"
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
    >
      <span className="flex items-center gap-2">
        Deslize para ver mais
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          animate={{ y: [0, 5, 0] }}
          transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </motion.svg>
      </span>
    </motion.div>
  </motion.div>
</header>

{/* Seção "Sobre Mim" - Ajustada para um visual mais clean e profissional */}
<motion.section
  id="sobre"
  className="py-16 px-6 text-center bg-gradient-to-b from-yellow-100 to-white"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 1 }}
  viewport={{ once: true }}
>
  <div className="max-w-4xl mx-auto flex flex-col items-center">
    
    {/* Foto de Perfil sem sobreposição de cor */}
    <div className="relative w-44 h-44 mb-6 rounded-full shadow-lg border-4 border-yellow-400 overflow-hidden">
      <img
        src={perfilImg}
        alt="Marineide Imóveis"
        className="w-full h-full object-cover"
      />
    </div>

    {/* Título estilizado */}
    <h2 className="text-4xl font-extrabold text-gray-800 tracking-wide">
      Sobre Mim
    </h2>

    {/* Linha decorativa */}
    <div className="w-24 h-1 bg-yellow-500 mx-auto my-4"></div>

    {/* Texto aprimorado */}
    <p className="text-lg text-gray-700 leading-relaxed max-w-2xl">
      Há <span className="font-bold text-yellow-600">18 anos</span> atuo no mercado imobiliário,
      ajudando clientes a encontrarem o imóvel perfeito. Acredito que cada lar tem uma história a contar,
      e minha missão é conectar você ao imóvel ideal com 
      <span className="font-semibold text-yellow-700"> transparência</span>, 
      <span className="font-semibold text-yellow-700"> profissionalismo</span> e 
      <span className="font-semibold text-yellow-700"> dedicação</span>! 
    </p>

    {/* Ícone do Instagram - Corrigido para não cortar */}
    <a
      href="https://www.instagram.com/marineide.imoveis/" // Substituir pelo link correto
      target="_blank"
      rel="noopener noreferrer"
      className="mt-8 flex flex-col items-center gap-3 text-yellow-600 hover:text-yellow-800 transition transform hover:scale-110"
    >
      <div className="flex items-center justify-center w-14 h-14 p-2 bg-yellow-100 rounded-full shadow-md border-none overflow-visible">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.345 3.608 1.32.975.975 1.258 2.242 1.32 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.345 2.633-1.32 3.608-.975.975-2.242 1.258-3.608 1.32-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.345-3.608-1.32-.975-.975-1.258-2.242-1.32-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.345-2.633 1.32-3.608.975-.975 2.242-1.258 3.608-1.32 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-1.281.059-2.54.334-3.487 1.28-.946.947-1.221 2.206-1.28 3.487-.058 1.28-.072 1.688-.072 4.947s.014 3.667.072 4.947c.059 1.281.334 2.54 1.28 3.487.947.946 2.206 1.221 3.487 1.28 1.28.058 1.688.072 4.947.072s3.667-.014 4.947-.072c1.281-.059 2.54-.334 3.487-1.28.946-.947 1.221-2.206 1.28-3.487.058-1.28.072-1.688.072-4.947s-.014-3.667-.072-4.947c-.059-1.281-.334-2.54-1.28-3.487-.947-.946-2.206-1.221-3.487-1.28-1.28-.058-1.688-.072-4.947-.072zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.846a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"/>
        </svg>
      </div>
      <span className="text-lg font-medium">Instagram</span>
    </a>
  </div>
</motion.section>



     {/* Seção de Destaques - Atualizada para um design premium */}
<motion.section
  id="imoveis"
  className="py-16 px-6 bg-gradient-to-b from-yellow-50 to-white"
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 1 }}
  viewport={{ once: true }}
>
  {/* Título estilizado */}
  <h2 className="text-4xl font-extrabold text-gray-800 text-center tracking-wide">
    🏢 Imóveis em Destaque
  </h2>

  {/* Linha decorativa */}
  <div className="w-24 h-1 bg-yellow-500 mx-auto my-4"></div>

  {/* Grid de imóveis */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 mt-10">
    {destaques.length > 0 ? (
      destaques.map((imovel) => (
        <motion.div
          key={imovel.id}
          className="bg-white shadow-lg rounded-2xl overflow-hidden transform hover:scale-105 transition duration-300 cursor-pointer hover:shadow-xl"
          onClick={() => setImovelSelecionado(imovel)}
          whileHover={{ scale: 1.05 }}
        >
          {/* Imagem do imóvel */}
          <img
            src={imovel.imagem}
            alt={imovel.titulo}
            className="w-full h-56 object-cover rounded-t-2xl"
          />

          {/* Conteúdo do card */}
          <div className="p-6">
            {/* Nome do imóvel */}
            <h3 className="text-2xl font-semibold text-gray-800">{imovel.titulo}</h3>

            {/* Localização */}
            <p className="text-gray-600 mt-1 flex items-center gap-2">
              📍 {imovel.localizacao}
            </p>

            {/* Preço */}
            <p className="text-xl font-bold text-yellow-600 mt-2">
              R$ {imovel.preco.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </p>

            {/* Ícones com características do imóvel */}
            <div className="flex items-center gap-4 mt-4 text-gray-700">
              <span className="flex items-center gap-1">
                🏠 {imovel.area}m²
              </span>
              <span className="flex items-center gap-1">
                🛏️ {imovel.quartos} quartos
              </span>
              <span className="flex items-center gap-1">
                🚗 {imovel.vagas} vagas
              </span>
            </div>
          </div>
        </motion.div>
      ))
    ) : (
      <p className="text-center text-gray-600 text-lg col-span-3">
        Nenhum imóvel em destaque no momento.
      </p>
    )}
  </div>
</motion.section>

{/* Modal de Detalhes do Imóvel */}
{imovelSelecionado && <ModalImovel imovel={imovelSelecionado} onClose={() => setImovelSelecionado(null)} />}


      {/* Ícone Flutuante do WhatsApp */}
      <motion.a
        href="https://wa.me/5511940321202"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 flex items-center justify-center bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-700 transition animate-bounce"
      >
        <FaWhatsapp size={32} />
      </motion.a>

      {/* Botão de Voltar ao Topo */}
      {mostrarTopo && (
        <motion.button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-6 bg-yellow-500 text-white p-3 rounded-full shadow-lg hover:bg-yellow-700 transition transform hover:scale-110"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <FaArrowUp size={24} />
        </motion.button>
      )}

      
    </div>
  );
}
